<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">

      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "main-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style>
</style>
